
import { Box, styled } from '@mui/material'
import React from 'react'
import { SOCIAL_MEDIA_LINKS } from 'constants/general'

const TopBox = styled(Box)({
  '& .logo-section':{
    
    '& .follow-us-top':{
      display: 'none',
    }
  },
  '& p':{
    fontSize: 15,
    fontFamily: 'Inter',
    fontWeight: 'normal',
    lineHeight: '24px',
    margin: 0,
    padding: '10px 0 0',
    color: '#FFF',
    maxWidth: '360px'
  },
  '& .follow-us':{
    display: 'flex',
    alignItems: 'center',
    '& span':{
      fontSize: 15,
      fontFamily: 'Inter',
      fontWeight: '500',
      lineHeight: '19px',
      color: '#FFF',
      padding: '0 20px 0 0',
    }
  },
  '@media only screen and (min-width: 320px) and (max-width: 768px)': {
    '& p':{
      padding: '0 0 10px',
    },
    '& .logo-section':{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',

      '& div':{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        margin: 0,
        '& img':{
          margin: '0 5px',
        }
      },
  
      '& .follow-us-top':{
        display: 'block',
      }
    },
    '& .follow-us':{
      display: 'none',
    }
  }
})

const FooterCompanyInformation = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{ marginTop: { xs: '2rem', sm: '0rem' } }}
    >
      <TopBox>
        <div className='logo-section'>
          <div><img src={require("assets/img/png/footer_logo.png")} /></div>
          <div className='follow-us-top'>
            <Box
              display="flex"
              mt={3}
              mb={3}
              justifyContent="space-between"
              width="50%"
            >
              <img
                src={require('assets/img/png/social/fb.png')}
                height={25}
                width={25}
                alt="Facebook"
                className="pointer-cur"
                onClick={() => window.open(SOCIAL_MEDIA_LINKS.FACEBOOK, '_blank')}
              />
              <img
                src={require('assets/img/png/social/instagram.png')}
                height={25}
                width={25}
                alt="Instagram"
                className="pointer-cur"
                onClick={() => window.open(SOCIAL_MEDIA_LINKS.INSTAGRAM, '_blank')}
              />
              <img
                src={require('assets/img/png/social/linkedIn.png')}
                height={25}
                width={25}
                alt="LinkedIn"
                className="pointer-cur"
                onClick={() => window.open(SOCIAL_MEDIA_LINKS.LINKEDIN, '_blank')}
              />
              <img
                src={require('assets/img/png/social/twitter.png')}
                height={25}
                width={25}
                alt="Twitter"
                className="pointer-cur"
                onClick={() => window.open(SOCIAL_MEDIA_LINKS.TWITTER, '_blank')}
              />
            </Box>
          </div>
        </div>
        <p>
          Haystackers is a peer to peer community-based platform facilitating
          direct rentals of tractors and farm equipment from individual farmers
          to those in need.
        </p>
        <div className='follow-us'>
          <span>Follow us</span>
          <Box
            display="flex"
            mt={3}
            mb={3}
            justifyContent="space-between"
            width="50%"
          >
            <img
              src={require('assets/img/png/social/fb.png')}
              height={25}
              width={25}
              alt="Facebook"
              className="pointer-cur"
              onClick={() => window.open(SOCIAL_MEDIA_LINKS.FACEBOOK, '_blank')}
            />
            <img
              src={require('assets/img/png/social/instagram.png')}
              height={25}
              width={25}
              alt="Instagram"
              className="pointer-cur"
              onClick={() => window.open(SOCIAL_MEDIA_LINKS.INSTAGRAM, '_blank')}
            />
            <img
              src={require('assets/img/png/social/linkedIn.png')}
              height={25}
              width={25}
              alt="LinkedIn"
              className="pointer-cur"
              onClick={() => window.open(SOCIAL_MEDIA_LINKS.LINKEDIN, '_blank')}
            />
            <img
              src={require('assets/img/png/social/twitter.png')}
              height={25}
              width={25}
              alt="Twitter"
              className="pointer-cur"
              onClick={() => window.open(SOCIAL_MEDIA_LINKS.TWITTER, '_blank')}
            />
          </Box>
        </div>
      </TopBox>
    </Box>
  )
}

export default FooterCompanyInformation
